<mat-form-field>
    <mat-label>{{ model.additional!['LABEL'] }} <span color="danger" *ngIf="model.required">*</span></mat-label>
    <mat-select [value]="value" [id]="model.id" (selectionChange)="onValueChanged($event)">
        <ng-container *ngFor="let option of model.datas">
            <mat-option [value]="option[model.valueField]">{{option[model.displayField]}}</mat-option>
        </ng-container>
    </mat-select>
</mat-form-field>